import { Stack } from 'components/Stack';
import styled from 'styled-components';
import { mediaAppMobile } from 'styles/grid';

const StepContainer = styled(Stack).attrs({
  gap: 16,
})`
  flex: 1 1 0;
`;

const IndicatorContainer = styled(Stack)``;

const Seperator = styled.div`
  border: 1px solid;
  border-color: ${({ theme }) =>
    theme.configs.trackingDetailsBox.headerAndFooter.bgColor};
  width: 100%;
  height: auto;
  ${mediaAppMobile} {
    width: 1px;
    height: 100%;
  }
`;

const StepIndx = styled.div`
  font-size: 12px;
  line-height: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${({ theme }) => theme.configs.CTAButton.bgColor};
`;

const StepTitle = styled.div`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
`;

const StepSubText = styled.div`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
`;

export {
  StepContainer,
  IndicatorContainer,
  Seperator,
  StepIndx,
  StepTitle,
  StepSubText,
};
